<template>
<v-container>
  <v-row>
    <v-col cols="12" md="2">
      <v-select
          :items="daysOptions"
          label="Days"
          v-model="days"
          @change="loadReposters"

      ></v-select>
    </v-col>
  </v-row>
  <v-data-table
      :headers="tableHeaders"
      :items="reposters"
      class="elevation-1"
      :search="search"
      :loading="isLoading"
      @click:row="rowOnClick"
  >

  </v-data-table>
</v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
const StatsRepo = RepositoryFactory.get('stats')

export default {
  name: "TopReposters",
  data: () => ({
    reposters: [],
    isLoading: true,
    search: '',
    days: 7,
    daysOptions: [1,7,30,365],
    tableHeaders: [
      {text: 'User', value: 'user'},
      {text: 'Repost Count', value: 'repost_count'}
    ]
  }),
  methods: {
    loadReposters() {
      this.isLoading = true;
      this.reposters = [];
      StatsRepo.getTopReposters({params: {days: this.days}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            this.isLoading = false;
            return;
          }
          this.reposters = res.data;
          this.isLoading = false;
        })
    },
    rowOnClick(row) {
      console.log('Row onclick')
      window.open(`https://reddit.com/u/${row.user}`)
    }
  },
  mounted() {
    this.loadReposters();
  }
}
</script>

<style scoped>

</style>